import { apiClient } from './apiClient';

export type TierName = 'BASIC' | 'LITE' | 'PRO' | 'GROWTH';

/** Feature flags added for the Lite tier (default true on richer tiers). */
export type EntitlementFeatureKey =
  | 'sequences_enabled'
  | 'campaigns_enabled'
  | 'bulk_email_enabled'
  | 'lead_suggestions_enabled'
  | 'prospecting_enabled'
  | 'enrichment_enabled'
  | 'lead_scoring_enabled'
  | 'upsells_enabled'
  | 'revenue_tracking_enabled'
  | 'advanced_analytics_enabled'
  | 'csv_import_enabled'
  | 'verticals_enabled'
  | 'chatbot_enabled'
  | 'website_forms_enabled'
  | 'api_access_enabled';

export interface Entitlements {
  tier: TierName;
  plan_code?: string;
  includes_portalr?: boolean;
  max_users: number;
  email_enabled: boolean;
  email_monthly_limit: number;
  custom_pipeline: boolean;
  automation_enabled: boolean;
  daily_lead_limit?: number;
  ai_features_enabled?: boolean;
  // Lite feature flags
  sequences_enabled?: boolean;
  campaigns_enabled?: boolean;
  bulk_email_enabled?: boolean;
  lead_suggestions_enabled?: boolean;
  prospecting_enabled?: boolean;
  enrichment_enabled?: boolean;
  lead_scoring_enabled?: boolean;
  upsells_enabled?: boolean;
  revenue_tracking_enabled?: boolean;
  advanced_analytics_enabled?: boolean;
  csv_import_enabled?: boolean;
  verticals_enabled?: boolean;
  chatbot_enabled?: boolean;
  website_forms_enabled?: boolean;
  api_access_enabled?: boolean;
  // Lite limits (null == unlimited)
  max_contacts?: number | null;
  chatbot_conversations_monthly?: number | null;
  form_submissions_monthly?: number | null;
  max_websites?: number | null;
  max_users_ceiling?: number | null;
  feature_flags?: Record<string, boolean>;
  email_verified?: boolean;
  trust_state?: 'normal' | 'trusted' | 'review' | 'restricted';
  high_risk_actions_allowed?: boolean;
}

class EntitlementService {
  /**
   * Fetch entitlements for the current tenant.
   * Returns feature flags and limits based on subscription tier.
   */
  async getEntitlements(): Promise<Entitlements> {
    const response = await apiClient.get('/entitlements/');
    return response;
  }
}

export const entitlementService = new EntitlementService();
